import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "فریلنس کار می‌کنید یا برای همکاری تمام‌وقت هم باز هستید؟",
      answer:
        "در حال حاضر به‌صورت Freelancer فعالیت می‌کنم و از انعطاف این مدل همکاری لذت می‌برم. با این حال اگر فرصت قوی و چالش‌برانگیزی وجود داشته باشد که به رشد حرفه‌ای من کمک کند، همکاری تمام‌وقت را هم بررسی می‌کنم.",
    },
    {
      question: "پروژه‌ها را به‌تنهایی انجام می‌دهید یا تیم هم دارید؟",
      answer:
        "من Team Lead و Hands-on Developer هستم. در پروژه‌های کوچک شخصاً اجرا را انجام می‌دهم و در پروژه‌های بزرگ‌تر، متناسب با Scope کار، با تیم همکاری می‌کنم.",
    },
    {
      question: "آیا پروژه‌های تحویل‌شده شامل پشتیبانی و نگهداری هستند؟",
      answer:
        "بله. تمام پروژه‌هایی که به‌صورت قراردادی تحویل می‌دهم شامل 6 ماه پشتیبانی و نگهداری رایگان هستند. بعد از آن، قرارداد Maintenance سالانه بر اساس درصدی از هزینه پروژه تعریف می‌شود تا پایداری سرویس حفظ شود.",
    },
    {
      question: "Source Code پروژه‌ها را تحویل می‌دهید؟",
      answer:
        "بله، مالکیت Source Code متعلق به کارفرما است و کد به‌صورت کامل، مستند و قابل نگهداری تحویل می‌شود.",
    },
  ];

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">پرسش‌های متداول</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">سؤالی دارید؟</h2>

            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{ __html: faq.answer }}></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            <img className="img-fluid" src="images/faq.png" title="FAQ" alt="faq" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
